/**
 * 从数据对象中取国际化字段值
 *
 * 按 `{field}_en` / `{field}_cn` / `{field}` 的优先级取值，
 * 调用方负责传入 isEN 判断。
 *
 * @example
 * getLocalizedValue(basicInfo, 'app_name', isEN)
 */
export const getLocalizedValue = (
  data: Record<string, any> | null | undefined,
  field: string,
  isEN: boolean,
): string => {
  if (!data) return '';
  return data?.[`${field}_${isEN ? 'en' : 'cn'}`] || data?.[field] || '';
};
